import { createContext } from "react";

const tokenContext = createContext();

export default tokenContext;
